(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-bbh-video]').forEach((video) => {
      if (video.dataset.bbhBound) return;
      video.dataset.bbhBound = 'true';
      const ready = () => video.setAttribute('data-ready', 'true');
      if (video.readyState >= 2) ready();
      video.addEventListener('loadeddata', ready, { once: true });
    });

    scope.querySelectorAll('[data-bbh-menu-toggle]').forEach((button) => {
      if (button.dataset.bbhBound) return;
      button.dataset.bbhBound = 'true';
      button.addEventListener('click', () => {
        const header = button.closest('[data-bbh-header]');
        const menu = header?.querySelector('[data-bbh-mobile-menu]');
        if (!menu) return;
        const open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        menu.hidden = open;
        document.documentElement.classList.toggle('bbh-menu-open', !open);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
